import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import { ChartTemplate } from "../chartTemplate";
import * as crossfilter from "crossfilter2/crossfilter";

    /* 
    dc-js chart template 
     */

    /*  Create a pie chart and use the given css selector as anchor. You can also specify
        an optional chart group for this chart to be scoped within. When a chart belongs
        to a specific group then any interaction with such chart will only trigger redraw
        on other charts within the same chart group.
   */ 
const agriactivitiesChartFunc = (divRef, ndx) => {
  //  create a fake bin to  remove nulls from the data
  function remove_empty_bins(source_group, key_to_remove) {
    return {
      all: function () {
        return source_group.all().filter(function (d) {
          //return Math.abs(d.value) > 0.00001; // if using floating-point numbers
          return d.key !== key_to_remove; // if integers only
        });
      },
    };
  }
  // Group proportion_HHFarming_categories by computing the sum of
  // proportion_of_Households_farming_percent in each categories

  const farming_household = ndx.dimension(
    (d) => d.proportion_HHFarming_categories
  );
  // Dimension by full proportion_HHFarming_categories
    var farming_household_grp = farming_household.group().reduceSum((d) => (d.proportion_of_Households_farming_percent)*100);
    // remove nulls from the nulls such that you don't have empty bars or pie slice

    const farming_household_grp_one = remove_empty_bins(
      farming_household_grp,
      null
    );
    const all = ndx.groupAll().reduceSum((d) => d.proportion_of_Households_farming_percent*100).value();

    /* Create chart objects associated with the container elements identified by the
         reference div.
    */
    var f = d3.format(".2f")
    const agriChart = dc.pieChart(divRef);
    // create an  instance of dc chart class
    agriChart
        .dimension(farming_household)
        .group(farming_household_grp_one)
        .width(150)
        .height(150)
        // .label(false)
        .legend(dc.legend().legendWidth(500).x(10).y(150).highlightSelected(true))
        .on('pretransition', function (chart) {
            chart.selectAll('text.pie-slice').text(function (d) {
                return dc.utils.printSingleValue((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%';
            })
        })
        //.drawPaths(true)
        //.on("pretransition", function (chart) {
        //    chart.label((d) => {
        //        let label = "";
        //        console.log("something")
        //        if (d.value < 100) {
        //            return label += `${f(d.value)} %`
        //        } else if (d.value > 100) {
        //            return label += `${f((d.value / all) * 100)} %`;
        //        } else if (d.value > 100 && d.value <all) {
        //            return label += `${f((d.value / all) * 100)} %`;
        //        }  
        //    })
        //})
        // (_optional_) by default pie chart will use `group.key` as its label ,in this case it has overwritten by  the closure.
        .renderTitle(false)
        //.label((d) => {
        //    let label = "";
        //    if (all) {
        //        console.log((d.value/all)*100)
        //        label += `${f((d.value / all)*100)} %`; // format  to  one decimal  place
        //    }
        //  return label;
        //})

    .innerRadius(28)
    .transitionDuration(1500)
    .ordinalColors(["#49B6A6", "#9ecae1"])
    .colorAccessor((d) => d.value);

  //  return the chart object to  the ChartTemplate
    return agriChart;
};

export const AgriActivitiesChart = (props) => (
  //  pass the chart object as a prop to the chart  function
    <ChartTemplate chartFunction={agriactivitiesChartFunc} title="" />
);
